(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["instagram-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('instagram-card-media')) {
    customElements.define(
      'instagram-card-media',
      class InstagramCardMedia extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;

          // Safari can drop the markup `muted` attribute when the node comes
          // in via section rendering — reassert it on the property or the
          // browser blocks the autoplay.
          this.video.muted = true;

          // Reduced-motion: hold on the poster frame, no playback.
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.removeAttribute('autoplay');
            this.video.pause();
            return;
          }

          // Only the card(s) actually on screen play — the slider keeps most
          // out of view, and several looping videos at once is a pointless
          // battery / CPU drain.
          this.observer = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (entry.isIntersecting) {
                  const played = this.video.play();
                  if (played) played.catch(() => {});
                } else {
                  this.video.pause();
                }
              }
            },
            { threshold: 0.25 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-accordion-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-scent-accordion')) {
    customElements.define(
      'variant-scent-accordion',
      class VariantScentAccordion extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('[data-variant-scent-details]');
          this.body = this.querySelector('[data-variant-scent-body]');
          this.onChange = (event) => {
            const field = event.target;
            // getAttribute, not form.id: the form's own `name="id"`
            // fields shadow its .id property.
            if (field.name !== 'id' || !field.form || field.form.getAttribute('id') !== this.dataset.formId) return;
            this.update(field.value);
          };
          document.addEventListener('change', this.onChange);
        }

        disconnectedCallback() {
          document.removeEventListener('change', this.onChange);
        }

        update(variantId) {
          const template = this.querySelector(`template[data-variant-scent-content="${CSS.escape(String(variantId))}"]`);
          if (!template || !this.details || !this.body) return;

          const content = template.innerHTML.trim();
          this.body.innerHTML = content;
          if (content) {
            this.hidden = false;
          } else {
            // Nothing to show for this variant — pull the row out rather
            // than leave an empty accordion on screen.
            this.details.open = false;
            this.details.dataset.expanded = 'false';
            this.hidden = true;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-burn-time-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('burn-time-accordion')) {
    customElements.define(
      'burn-time-accordion',
      class BurnTimeAccordion extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('[data-burn-time-details]');
          this.body = this.querySelector('[data-burn-time-body]');
          this.onRefillChanged = (event) => this.update(event.detail && event.detail.variantId);
          document.addEventListener('candle-refill:changed', this.onRefillChanged);

          // "bundle" mode pre-selects the first refill, so show its burn
          // time on load rather than waiting for the first drawer change.
          const drawer = document.getElementById('candle-refill-scent-drawer');
          const checked = drawer && drawer.querySelector('input[type="radio"]:checked');
          if (checked) this.update(checked.value);
        }

        disconnectedCallback() {
          document.removeEventListener('candle-refill:changed', this.onRefillChanged);
        }

        update(variantId) {
          if (!this.details || !this.body) return;

          const id = variantId == null ? '' : String(variantId);
          const template = id
            ? this.querySelector(`template[data-burn-time-variant="${CSS.escape(id)}"]`)
            : null;
          const burnTime = template ? template.innerHTML.trim() : '';

          if (burnTime) {
            this.body.innerHTML = burnTime;
            this.hidden = false;
          } else {
            // Chosen refill has no burn time — pull the row back out
            // rather than leave an empty accordion on screen.
            this.body.innerHTML = '';
            this.details.open = false;
            this.details.dataset.expanded = 'false';
            this.hidden = true;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-card-recipient-form')) {
    customElements.define(
      'gift-card-recipient-form',
      class GiftCardRecipientForm extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('.product-gift-recipient__toggle-input');
          this.fields = this.querySelector('[data-gift-recipient-fields]');
          this.fallback = this.querySelector('[data-gift-recipient-fallback]');
          this.offset = this.querySelector('[data-gift-recipient-offset]');
          this.email = this.querySelector('input[name="properties[Recipient email]"]');
          this.submitButton = this.querySelector('[data-add-to-cart-button]');

          this.checkbox.disabled = false;
          this.fallback.disabled = true;
          if (this.offset) this.offset.value = new Date().getTimezoneOffset().toString();

          this.checkbox.addEventListener('change', () => this.sync());
          this.sync();
        }

        sync() {
          const active = this.checkbox.checked;

          this.fields.hidden = !active;
          this.fields.querySelectorAll('input, textarea').forEach((field) => {
            field.disabled = !active;
            if (!active) field.value = '';
          });

          if (this.email) this.email.required = active;
          if (this.offset) this.offset.disabled = !active;
          if (this.submitButton) this.submitButton.hidden = !active;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-scent-notes-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scent-notes-accordion')) {
    customElements.define(
      'scent-notes-accordion',
      class ScentNotesAccordion extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('[data-scent-notes-details]');
          this.body = this.querySelector('[data-scent-notes-body]');
          this.onRefillChanged = (event) => this.update(event.detail && event.detail.variantId);
          document.addEventListener('candle-refill:changed', this.onRefillChanged);
        }

        disconnectedCallback() {
          document.removeEventListener('candle-refill:changed', this.onRefillChanged);
        }

        update(variantId) {
          if (!this.details || !this.body) return;

          const id = variantId == null ? '' : String(variantId);
          const template = id
            ? this.querySelector(`template[data-scent-notes-variant="${CSS.escape(id)}"]`)
            : null;
          const notes = template ? template.innerHTML.trim() : '';

          if (notes) {
            this.body.innerHTML = notes;
            this.hidden = false;
          } else {
            // Chosen refill has no scent notes — pull the row back out
            // rather than leave an empty accordion on screen.
            this.body.innerHTML = '';
            this.details.open = false;
            this.details.dataset.expanded = 'false';
            this.hidden = true;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["production-timetable"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('production-timetable-remote')) {
    customElements.define(
      'production-timetable-remote',
      class ProductionTimetableRemote extends HTMLElement {
        connectedCallback() {
          this.rows = this.querySelector('[data-rows]');
          this.onCandleHolderChanged = (event) => this.load(event.detail.url);
          document.addEventListener('candle-holder:changed', this.onCandleHolderChanged);
        }

        disconnectedCallback() {
          document.removeEventListener('candle-holder:changed', this.onCandleHolderChanged);
        }

        // Stays hidden until the first selection — nothing (heading,
        // subtext, or the timetable box) shows before then. Once a holder
        // with a timetable has been picked it stays visible and keeps
        // whatever's currently in .production-timetable__rows on screen
        // (the previously selected holder's timetable) for the duration of
        // each fetch — only a dimmed overlay + spinner communicates the
        // pending state, so switching holders after that never blanks the
        // widget or shifts surrounding layout. If the picked holder's page
        // has no timetable at all, the whole widget is hidden again rather
        // than showing a placeholder message. Guards against races (an
        // earlier request resolving after a newer selection) by only
        // applying a response if it still matches the most recently
        // requested url.
        load(url) {
          this.requestedUrl = url;

          if (!url) {
            this.hidden = true;
            this.classList.remove('is-loading');
            return;
          }

          // Only reveal up front when there's already a timetable on screen
          // to keep showing (dimmed, under the spinner) during the fetch. On
          // the first pick we stay hidden until we know rows came back, so
          // there's never an empty spinner box.
          if (!this.hidden) this.classList.add('is-loading');

          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              if (this.requestedUrl !== url) return;

              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fetchedList = doc.querySelector('.production-timetable__list');
              const rowsHtml = fetchedList ? fetchedList.innerHTML.trim() : '';

              if (rowsHtml) {
                this.rows.innerHTML = rowsHtml;
                this.hidden = false;
              } else {
                // This holder has no production timetable — hide the whole
                // widget instead of showing an "unavailable" message.
                this.rows.innerHTML = '';
                this.hidden = true;
              }
            })
            .catch(() => {})
            .finally(() => {
              if (this.requestedUrl !== url) return;
              this.classList.remove('is-loading');
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
